if (!customElements.get('dc-product-ambient-image')) {
  class DCProductAmbientImage extends HTMLElement {
    connectedCallback() {
      this.handleContextMenu = this.handleContextMenu || this.onContextMenu.bind(this);
      this.addEventListener('contextmenu', this.handleContextMenu);
    }

    disconnectedCallback() {
      this.removeEventListener('contextmenu', this.handleContextMenu);
    }

    onContextMenu(event) {
      const image = event.target?.closest?.('.dc-product-ambient-image__image');

      if (image && this.contains(image)) {
        event.preventDefault();
      }
    }
  }

  customElements.define('dc-product-ambient-image', DCProductAmbientImage);
}
